import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *班级平均分
 * @param classId
 * 
*/

export const classAvg = classId => Http.get(`${baseUrl}/statistics/${classId}/avg`)

/**
 *团队排行
 * @param classId
 * 
*/

export const teamRanking = classId => Http.get(`${baseUrl}/statistics/${classId}/team`)

/**
 *个人排行
 * @param classId
 * 
*/

export const personalRanking = classId => Http.get(`${baseUrl}/statistics/${classId}/user`)

/**
 *最终成绩排行榜
 * @param classId
 * 
*/

export const personalFinalRanking = classId => Http.get(`${baseUrl}/statistics/${classId}/final`)

/**
 *学生排行榜
 * @param classId
 * 
*/

export const userRankingList = classId => Http.get(`${baseUrl}/statistics/${classId}/userList`)

/**
 *团队排行榜
 * @param classId
 * 
*/

export const teamRankingList = classId => Http.get(`${baseUrl}/statistics/${classId}/teamList`)

/**
 *我的(团队)章节成绩
 * @param params
 * 
*/

export const myScore = params => Http.get(`${baseUrl}/statistics/${params.classId}/${params.type}/chapter`)


/**
 *知识考核个人习题情况
 * @param params
 * 
*/

export const userQuestion = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/question`, { params })

/**
 *态度考核详情
 * @param params
 * 
*/

export const userTdDetail = params => Http.get(`${baseUrl}/statistics/td/info`, { params })

/**
 *素养考核个人成绩列表
 * @param params
 * 
*/

export const userSyScoreList = params => Http.get(`${baseUrl}/statistics/sy/info`, { params })

/**
 *我的知识章节成绩信息
 * @param params
 * 
*/

export const userZs = params => Http.get(`${baseUrl}/statistics/zs/tj`, { params })

/**
 *我的态度章节成绩信息
 * @param params
 * 
*/

export const userTd = params => Http.get(`${baseUrl}/statistics/td/tj`, { params })
